import { render, staticRenderFns } from "./DelegationOrderDecisionForm.vue?vue&type=template&id=94560e86&scoped=true&"
import script from "./DelegationOrderDecisionForm.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderDecisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94560e86",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94560e86')) {
      api.createRecord('94560e86', component.options)
    } else {
      api.reload('94560e86', component.options)
    }
    module.hot.accept("./DelegationOrderDecisionForm.vue?vue&type=template&id=94560e86&scoped=true&", function () {
      api.rerender('94560e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationOrder/DelegationOrderDecisionForm.vue"
export default component.exports